import { useIntlModule } from 'utils/intl/useIntlModule';
import messages from './snackBarProvider.intl.json';

export const useSnackBarProviderIntl = () => useIntlModule(messages);
